import React, { createElement } from 'react';
import classNames from 'classnames';
import './index.scss';
export const ColorfulSpace = props => {
    const prefixCls = `au-space`;
    const { direction, gap, justify, align, children } = props;
    return (createElement("div", { className: classNames(prefixCls, {
            [`${prefixCls}-${direction}`]: true,
            [`${prefixCls}-align-${align}`]: !!align,
            [`${prefixCls}-justify-${justify}`]: !!justify,
        }), style: { '--gap': gap + 'px' || '10px' } }, React.Children.map(children, child => {
        return (child !== null &&
            child !== undefined && (createElement("div", { className: `${prefixCls}-item` }, child)));
    })));
};
ColorfulSpace.displayName = 'ColorfulSpace';
export default ColorfulSpace;
